module.exports = __webpack_public_path__ + "img/22@2x.a79a4837.png";